import { gql } from '@apollo/client';
import { SEND_CONTACT_MESSAGE_OPERATION } from 'utils/constants';

export const SEND_CONTACT_MESSAGE = gql`
  mutation ${SEND_CONTACT_MESSAGE_OPERATION}($messageInput: MessageInput) {
    messageCalixUser(input: $messageInput)
  }
`;
